import React from 'react';
import './Experience.css'
import './General.css'

function Experience() {
  return <>
  <div id='experience' className='container'>
    <div className='title'><span className='title_num'>01. </span>My Work Experience</div>
      <div className=''>About my experience
      </div>
  </div>
  </>
}

export default Experience;
